/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Pin_LabelInputs */



/**
* | output |
* | --- |
* | "Pin {name}" |
*
* @param {Voice_Manager_Pin_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pin_label = /** @type {((inputs: Voice_Manager_Pin_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pin_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Epingler ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Pin ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Spillo ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Pin ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pin ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`引脚 ${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ピン ${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पिन ${i?.name}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Pino ${i?.name}`)
	return /** @type {LocalizedString} */ (`Pin ${i?.name}`)
});